import PostBodyComponents from './PostBodyComponents';

export default PostBodyComponents;
